import { render, staticRenderFns } from "./QuizHistory.vue?vue&type=template&id=4e5c7b8b"
import script from "./QuizHistory.vue?vue&type=script&lang=js"
export * from "./QuizHistory.vue?vue&type=script&lang=js"
import style0 from "./QuizHistory.vue?vue&type=style&index=0&id=4e5c7b8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports